import { render } from "./MembroForm.vue?vue&type=template&id=7be2bb69"
import script from "./MembroForm.vue?vue&type=script&lang=js"
export * from "./MembroForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__